import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

export type ConvertWorkScheduleToOpenSlotPayload = {
  workScheduleSlotId: string;
  occurrenceDate: string;
  slotType: 'fullvisio' | 'mixed';
};

export const useConvertWorkScheduleToOpenSlotMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({
      workScheduleSlotId,
      occurrenceDate,
      slotType,
    }: ConvertWorkScheduleToOpenSlotPayload) => {
      return http.workScheduleSlots.convert(workScheduleSlotId, {
        occurrenceDate,
        slotType,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['office-work-schedule-slots'],
      });
      queryClient.invalidateQueries({
        queryKey: ['office-agenda-slots'],
      });
      toast.success(t('view-admin-work-schedule-slot-sheet.convert.success'));
    },
    onError: () => {
      toast.error(t('view-admin-work-schedule-slot-sheet.convert.error'));
    },
  });
};
